import React from "react";
import { AsyncPaginate, type LoadOptions } from "react-select-async-paginate";

interface CommonOption {
  label: string;
  value: string;
  [key: string]: any; // allows extra fields
}

interface AsyncPaginateSelectProps {
  name: string;
  value: CommonOption | null;
  loadOptions: LoadOptions<CommonOption, any, any>;
  onChange: (option: CommonOption | null) => void;
  placeholder?: string;
  debounceTimeout?: number;
  className?: string;
  additional?: any;
  isClearable?: boolean;
}

export const AsyncPaginateSelect: React.FC<AsyncPaginateSelectProps> = ({
  name,
  value,
  loadOptions,
  onChange,
  placeholder = "Select...",
  debounceTimeout = 300,
  className = "w-full",
  additional = { page: 1 },
  isClearable = true,
}) => {
  return (
    <AsyncPaginate
      name={name}
      value={value}
      loadOptions={loadOptions}
      onChange={onChange}
      additional={additional}
      debounceTimeout={debounceTimeout}
      placeholder={placeholder}
      className={className}
      isClearable={isClearable}
    />
  );
};
